import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import { omit } from "lodash";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

export interface FormHeadingBlockProps extends ComponentPropsWithRef<"div"> {
  textType?: "title" | "subtitle";
  value?: string;
}

export const FormHeadingBlock = forwardRef<
  HTMLDivElement,
  FormHeadingBlockProps
>(({ value, textType = "title", className, ...rest }, ref) => {
  const elementProps = omit(rest, ["blockPath"]);
  const TypographyComponent =
    textType === "title" ? Typography.TitleMd : Typography.TitleSm;

  return (
    <div ref={ref} className={classNames("mb-2", className)} {...elementProps}>
      <TypographyComponent>
        {value || t("builder_ui.prop_type.text_content_empty")}
      </TypographyComponent>
    </div>
  );
});

FormHeadingBlock.displayName = "FormHeadingBlock";
